export var AddSubPageCommand = "Add sub-page";
export var CloneWikiCommand = "Clone wiki";
export var WikiSecurityCommand = "Wiki security";
export var CreateWikiCTAText = "Create Wiki";
export var CreatingWikiCTAText = "Creating ...";
export var DeleteCommand = "Delete";
export var DemotePageCommand = "Demote page";
export var OpenInNewTab = "Open in new tab";
export var EditCommand = "Edit";
export var FavoriteCommand = "Favorite";
export var PromotePageCommand = "Promote page";
export var SetAsHomeCommand = "Set as wiki homepage";
export var ToggleSidebarCommand = "Toggle sidebar";
export var ViewRevisionsCommand = "View revisions";
export var Pages = "Pages";
export var ZeroDataPrimaryText = "Get everyone on the same page";
export var ZeroDataSecondaryText = "Create wiki pages to help your team members collaborate.";
export var Preview = "Preview";
export var ErrorMessage_PageNotFound = "Page \u0027{0}\u0027 does not exist";
export var Error_PageNotFound = "Page does not exist";
export var CancelButtonText = "Cancel";
export var EditPageButtonText = "Edit page";
export var EditInReposText = "Edit in {0}";
export var MoreComandsMenuText = "More";
export var NewPageButtonText = "New page";
export var SaveButtonText = "Save";
export var ErrorMessage_WikiCreationFailed = "We were unable to create wiki. Please refresh the page and try again. Message: {0}";
export var RevisionsString = "Revisions";
export var PageTitlePlaceHolderText = "Page title";
export var PageTitleAriaLabel = "Page title";
export var CloneWikiDialog_Title = "Clone repo";
export var CloneWikiDialog_CompletedLoadingComponent = "Loading completed";
export var CloneWikiDialog_StartedLoadingComponent = "Loading clone wiki dialog";
export var DeletePageDefaultComment = "Deleted {0}";
export var AddPageDefaultComment = "Added {0}";
export var EditPageDefaultComment = "Updated {0}";
export var RenamePageDefaultComment = "Renamed page \u0027{0}\u0027 to \u0027{1}\u0027";
export var SetAsHomeDefaultComment = "Page \"{0}\" is set as home page";
export var MovePageDefaultComment = "Page \u0027{0}\u0027 moved from parent \u0027{1}\u0027 to \u0027{2}\u0027";
export var ReorderPageDefaultComment = "Page \u0027{0}\u0027 moved from order \u0027{1}\u0027 to \u0027{2}\u0027";
export var DeleteButtonText = "Delete";
export var DiscardButtonText = "Discard";
export var NavigateAwayDialog_NamedMessage = "You have unsaved changes made to page \u0027{0}\u0027 which will be lost if you navigate away. Would you like to save changes before proceeding?";
export var EditPage_CancelDialogTitle = "Unsaved changes";
export var EditPage_DeleteDialogMessage = "\u0027{0}\u0027 page and its sub-pages (if any) along with all the associated metadata will be deleted. Are you sure you want to continue?";
export var EditPage_DeleteDialogTitle = "Delete page";
export var EditPage_UnsavedContentNavigateAwayMessage = "Page content changes you made may not be saved.";
export var SavePageDialog_SavingPageText = "Saving page...";
export var SavePageDialog_Title = "Save Page";
export var DeletePageDialog_DeletingPageText = "Deleting page...";
export var HistoryPageTitle = "Revisions";
export var CopyPagePathCommand = "Copy page path";
export var WikiSecurityTitle = "Security for Wiki";
export var WindowTitleDefault = "Wiki";
export var WindowTitleForComparePage = "{0} compare - Wiki";
export var WindowTitleForNewPage = "New page - Wiki";
export var WindowTitleForRevisionsPage = "{0} revision - Wiki";
export var WindowTitleWhileEditing = "Editing {0} - Wiki";
export var PageTitleInvalid = "Invalid page title. Title cannot begin or end with \".\"";
export var PageTitleInvalidCharacter = "Invalid page title. The page title cannot contain any of the following characters: /  \\ #";
export var WikiHistoryCommitHashColumnName = "Version";
export var WikiHistoryDateColumnName = "Last Updated";
export var CompareTabTitle = "Compare";
export var MovePageDialog_Message = "Moving page \u0027{0}\u0027 may break its links if it is linked from another page. You can always fix the links manually after you move. The new path of the page that needs to be manually updated at all linked pages is \u0027{1}\u0027. Would you like to proceed?";
export var MovePageDialog_MoveButtonText = "Move";
export var MovePageDialog_MovingPageText = "Moving page...";
export var MovePageDialog_Title = "Move page";
export var EditWiki_InsufficientPermissions = "You do not have permissions to edit this page.";
export var SavePageDialog_RenameInfoMessage = "Renaming page may break its links, if it is linked from another page. You can always fix the links manually after you save.";
export var SetAsHomePageDialog_Message = "Setting \"{0}\" as home page will break its links, if it is linked from other pages. After setting it as home page, you will need to copy the page path and fix it in all linked pages manually. Would you like to proceed?";
export var SetAsHomePageDialog_SetAsHomeButtonText = "Set as home";
export var SetAsHomePageDialog_SettingAsHomePageText = "Setting as home page...";
export var SetAsHomePageDialog_Title = "Set as home page";
export var NewPagePlaceHolderTitle = "\u003cNew page\u003e";
export var NavigateAwayDialog_DefaultMessage = "You have unsaved changes made to this page which will be lost if you navigate away. Would you like to save changes before proceeding?";
export var NoPermissionsSecondaryText = "Either there is no Wiki in this project yet, or all the pages are private right now.";
export var Attachment_NotSupportedFileType = "The file type {0} is not valid for attachments.";
export var CloseButtonText = "Close";
export var NonConformanceError_ForAddSubPage = "Could not add sub page for the page \u0027{0}\u0027. Either the page\u0027s title or any of its ancestor page\u0027s title does not conform to Wiki standards.";
export var NonConformanceError_ForDelete = "Could not delete page \u0027{0}\u0027. Either the page\u0027s title or any of its ancestor page\u0027s title does not conform to Wiki standards.";
export var NonConformanceError_ForEdit = "Could not edit page \u0027{0}\u0027. Either the page\u0027s title or any of its ancestor page\u0027s title does not conform to Wiki standards.";
export var NonConformanceError_ForLoad = "Could not load page \u0027{0}\u0027. Either the page\u0027s title or any of its ancestor page\u0027s title does not conform to Wiki standards.";
export var NonConformanceError_ForSetAsHomePage = "Could not set page \u0027{0}\u0027 as home page. Either the page\u0027s title or any of its ancestor page\u0027s title does not conform to Wiki standards.";
export var NonConformanceError_ForViewRevisions = "Could not load revisions for the page \u0027{0}\u0027. Either the page\u0027s title or any of its ancestor page\u0027s title does not conform to Wiki standards.";
export var Attachment_MultipleNotSupportedFileTypes = "The file type {0} and {1} are not valid for attachments.";
export var FilterTreeWatermarkText = "Filter pages by title";
export var NoResultsFoundMessage = "No results found";
export var ResultsLoadedMessage = "Results loaded";
export var FilteredPages = "Filtered pages";
export var NoPermissionsPrimaryText = "Nothing to see here";
export var NoPermissionsLearnMore = "Learn more about wiki";
export var NoPermissionsLearnMoreLink = "https://go.microsoft.com/fwlink/?linkid=852630";
export var ErrorMessage_AncestorConflicts = "One or more pages in the hierarchy of the page \u0027{0}\u0027 does not exist anymore. Copy your changes if any, refresh the browser to receive the latest pages and then try your changes again.";
export var ErrorMessage_PageConflict_Updated = "Unable to update the page \u0027{0}\u0027 as it has been modified by another user. Copy your changes, refresh the browser to receive the latest pages and then try your changes again.";
export var EditAndRenamePageDefaultComment = "Updated content and renamed page \u0027{0}\u0027 to \u0027{1}\u0027";
export var LearnMoreLabel = "Learn more";
export var NonConformanceError_LearnMoreLink = "https://go.microsoft.com/fwlink/?linkid=852630";
export var NonConformanceError_ToFixThis = " on how to fix this issue.";
export var Attachment_UnSupportedCharactersInName = "Attachment name with characters ({0}) are not supported. Following files have these characters:";
export var Attachment_FileSizeExceeded = "Attachments must be less than {0} MB. Following files exceed the size limit:";
export var ErrorMessage_PageConflict_Deleted = "Unable to update the page \u0027{0}\u0027 as it has been deleted by another user. Copy your changes, refresh the browser to receive the latest pages and then try your changes again.";
export var MarkdownDocumentLink = "https://go.microsoft.com/fwlink/?linkid=851652";
export var ErrorMessage_VersionNotFound = "Wiki version ‘{0}’ could not be found. Ensure that the version exists.";
export var PagePathTooLong = "Invalid page title. The page path should not exceed {0} characters.";
export var PageTitleEmpty = "Page title cannot be empty";
export var RevisionDetailsRevertButton = "Revert";
export var RevisionDetailsRevertDialogTitle = "Revert revision {0}";
export var RevisionDetailsRevertDialogSubtitle = "Revert the changes made in this revision";
export var RevisionDetailsRevertCompletionMessage = "Successfully reverted the changes made in this revision";
export var BrowsePage = "Browse Page";
export var ErrorMessage_FileSizePolicy = "Unable to save the page since compressed size of one or more attachments is exceeding current limit of 4 MB per file. You can remove such file(s) and try to save again.";
export var FilteringInProgressAriaLabel = "Filtering in progress...";
export var HomePage_AriaLabel = "Home Page {0}";
export var Page_AriaLabel = "Page {0}";
export var PageReorderFailedMessage = "Reorder of page \u0027{0}\u0027 has failed.";
export var PageReorderStartedMessage = "Reorder of page \u0027{0}\u0027 has started.";
export var PageReorderSucceededMessage = "Reorder of page \u0027{0}\u0027 has completed.";
export var RevertDisabledCalloutHeader = "Why is revert disabled?";
export var RevertDisabledPageAddDescription = "The page was added in this revision. Reverting this revision can impact the page order and links. We recommend that you delete this page manually.";
export var RevertDisabledRenameDescription = "The page was renamed or moved in this revision. Reverting this revision can impact the page order and links. We recommend that you rename or move this page manually.";
export var GotoWikiHome = "Go to Wiki home";
export var ErrorMessage_PageNotFound_ParentNonExistant = "The link appears to be broken. Ensure all pages in the link exist.";
export var CreatPageText = "Create Page";
export var TextEditor_AriaLabel = "Edit wiki page. ";
export var InfoErrorPageCreationAtPathMessage = "\u0027{0}\u0027 will be created under \u0027{1}\u0027";
export var InfoErrorPageCreationAtRootMessage = "\u0027{0}\u0027 will be created at the root of the Wiki";
export var MovePageCommand = "Move page";
export var DialogCloseButtonAriaLabel = "Close the dialog";
export var MoveToPagePickerTitle = "Move \u0027{0}\u0027 page to";
export var MovePagePickerDialogText = "Moving a page will modify its path and may break its links if it is linked from another page. You can always fix the links manually.";
export var GetPagesToFilterFailedError = "Error occured while fetching the pages for filtering.";
export var MessageBarDismissButtonAriaLabel = "Dismiss this message";
export var PreviewMode_Full = "Preview only";
export var PreviewMode_Live = "Edit and preview";
export var PreviewMode_Off = "Edit only";
export var Attachment_SaveFailed = "Could not save the changes to the page since saving one or more attachments failed.";
export var PageContentSizeExceeded = "Cannot further add content. The page being edited is {0} MB which exceeds the max size of {1} MB at a time. You can save the current page and continue to proceed.";
export var Root = "Root";
export var SaveCalloutHeader = "Save with revision message";
export var SavePageDefaultMessage = "Saved page with message";
export var SavePageMessageHeader = "Revision Message";
export var Updated = "Updated {0}\u0027  ";
export var MarkdownPasteHTML = "Paste as HTML";
export var MarkdownUnwrapText = "Disable word wrap";
export var MarkdownWrapText = "Enable word wrap";
export var SynchronizeScrollEnableText = "Enable Synchronized scroll";
export var SynchronizeScrollDisableText = "Disable Synchronized scroll";
export var DisableSynchronizeScrollToggle = "Synchronized scroll is not applicable in edit only mode";
export var SynchronizedScroll = "Synchronized scroll";
export var MarkdownTable = "Table options";
export var TableInsertedText = "A {0} by {1} table has been created and the cursor is in first cell of the table";
export var TablesFormattedText = "Tables formatted";
export var WordWrapDisabledText = "Word wrap disabled";
export var WordWrapEnabledText = "Word wrap enabled";
export var ErrorMessage_PageConflict_AlreadyAdded = "Unable to add the page \u0027{0}\u0027 as it has been added already by another user. Copy your changes, refresh the browser to receive the latest pages and then try adding your content with a new page title.";
export var SaveShortcut = "Save (Ctrl+S)";
export var AddPageContent = "Add page content";
export var ErrorMessage_PageContentUnavailable = "Content is not available for this parent page.";
export var LinkFormPageUpdatedDescription = "Updated {0}";
export var LinkFormWikiPageNotFound = "Page may have been renamed or deleted.";
export var RelatedArtifactsWikiPageTitle = "Wiki page";
export var LinkWorkItemsCommand = "Link work items";
export var LinkWorkItemsDialogHeaderLabel = "Link work items";
export var UpdateButtonText = "Update";
export var UpdatingWorkItemsSpinnerText = "Updating work items";
export var LinkWorkItemsDialogMessage = "You are linking work items to \u0027{0}\u0027.";
export var LinkWorkItemsZeroDataText = "There are no work items linked to this page.";
export var OkText = "OK";
export var WITFormDuplicateWikiPage = "The wiki page \u0027{0}\u0027 is already linked to this work item";
export var WITFormNoWikiError = "This project does not contain a wiki.";
export var WITFormSelectWikiPageText = "Select wiki page";
export var WITFormSelectWikiPageToLinkText = "Select Page to link to the work item";
export var WITFormWikiPageDoesNotExist = "The wiki page \u0027{0}\u0027 does not exist.";
export var WITFormWikiPageLabel = "Wiki page";
export var WITFormWikiPagePathNotSpecified = "Wiki page path was not specified.";
export var WITFormWikiPagePathPlaceholder = "Wiki page path";
export var ExpandSaveButtonAriaLabel = "Save with revision message";
export var RevertDisabledDeleteDescription = "The page was deleted in this revision. Reverting this revision can impact the page order and links. We recommend that you add this page manually.";
export var WikiFormFolderFieldLabel = "Folder";
export var WikiFormFolderFieldPlaceHolder = "Select a folder";
export var WikiFormPublishOperationMessage = "Markdown pages from the selected folder in the code repository will be published as Wiki.";
export var WikiFormPublishCTALabel = "Publish";
export var WikiFormRepositoryFieldLabel = "Repository";
export var WikiFormPublishOperationTitle = "Publish pages from code repository as Wiki";
export var WikiFormBranchFieldLabel = "Branch";
export var WikiFormWikiNameFieldLabel = "Wiki name";
export var WikiFormWikiNameFieldPlaceHolder = "Enter wiki name";
export var WikiFormPublishSpinnerLabel = "Publishing wiki...";
export var WikiFormBranchFieldPlaceHolder = "Select a branch";
export var WikiFormFolderFieldInvalid = "Invalid path value. Path should start with \"/\".";
export var WikiFormNameAlreadyExisting = "Wiki name already exists. Use a different wiki name.";
export var KeyboardShortcutDescription_QuickSave = "Save changes";
export var WikiHubKeyboardShortcutGroup = "Wiki";
export var KeyboardShortcutDescription_CreateNewSubpage = "Create new sub-page";
export var KeyboardShortcutDescription_Close = "Close";
export var KeyboardShortcutDescription_EditPage = "Edit page";
export var KeyboardShortcutDescription_FilterPage = "Filter page";
export var KeyboardShortcutDescription_MovePageDown = "Move page down the order";
export var KeyboardShortcutDescription_MovePageUp = "Move page up the order";
export var KeyboardShortcutDescription_NewPage = "Add new page";
export var KeyboardShortcutDescription_SaveAndClose = "Save and Close";
export var WikiEditModeKeyboardShortcutGroup = "Wiki edit";
export var WikiFormNameInvalid = "The wiki name is invalid.";
export var WikiPrintCommand = "Print page";
export var KeyboardShortcutDescription_PrintPage = "Print current page";
export var WikiPickerCreateWikiActionText = "Create new wiki";
export var WikiPickerLoadingWikisText = "Loading wikis...";
export var WikiPickerPublishWikiActionText = "Publish code as wiki";
export var WikiPickerSearchTextPlaceholder = "Filter wikis";
export var WikiPickerNoWikisText = "No wikis available";
export var BreadcrumbRoot = "Wikis";
export var WikiBreadcrumb_Arialabel = "Wiki Breadcrumbs";
export var WikiFormUpdateOperationMessage = "Markdown pages from another version from the selected repository and folder will be published as wiki.";
export var WikiFormUpdateOperationTitle = "Publish new version of Wiki";
export var WikiFormUpdateSpinnerLabel = "Updating wiki...";
export var BranchPickerNoBranchText = "No branch available";
export var BranchPickerPublishBranchActionText = "Publish new branch";
export var BranchPickerSearchTextPlaceholder = "Filter branches";
export var WikiFormDataLoadingSpinnerText = "Loading initial data...";
export var ErrorMessage_NoValidPagesInWiki = "There are no valid pages in this wiki";
export var ErrorMessage_PathIsAFolder = "\u0027{0}\u0027 maps to a folder in the code repository";
export var ErrorMessage_ZeroPagesInWiki = "There are no pages in this wiki";
export var GoToCodeButtonText = "Go to code";
export var SecondaryErrorMessage_NoValidPagesInWiki = "Ensure the pages follow the wiki naming standards. {0}.";
export var SecondaryErrorMessage_ZeroPagesInWiki = "Add markdown pages to the code repository to show up in wiki.";
export var LearnMoreLink_NoValidPages = "https://go.microsoft.com/fwlink/?linkid=851521";
export var LearnMoreLink_ProductDocumentationBlog = "https://go.microsoft.com/fwlink/?linkid=866310";
export var SecondaryErrorMessage_PathIsAFolder = "{0} to promote the \u0027{1}\u0027 to a wiki page.";
export var PublishCodeAsWiki = "Publish code as Wiki";
export var PublishCodeRepositoryHelpText = "Learn more to publish code as Wiki.";
export var PrintMetaData = "Last updated by | {0} | {1}";
export var LastUpdated = "Last updated";
export var LastUpdatedOn = "Last updated on";
export var LoadWikiTemplateFailed = "Template \u0027{0}\u0027 could not be loaded.";
export var TemplatePickerTitle = "Choose template";
export var AsyncLabelLoadingAriaLabel = "Label content is loading.";
export var TemplatePickerFilterBoxText = "Filter templates";
export var TemplatePickerNameAriaLabel = "Wiki template name is \u0027{0}\u0027. ";
export var TemplatePickerNoFilteredTemplatesMessage = "No templates available for the filtered text.";
export var TemplatePickerNoTemplatesMessage = "No templates available.";
export var TemplatePickerErrorDescriptionMessage = "Could not load the template description.";
export var TemplatePickerNoDescriptionMessage = "\u003cNo description available\u003e";
export var TemplatePickerDescriptionAriaLabel = "Template description is \u0027{0}\u0027.";
export var TemplatePickerBlankTemplateDescription = "Start with a blank page";
export var TemplatePickerBlankTemplateName = "Blank page";
export var NavigateToMicropediaHomeToolTip = "Go to the Micropedia home page";
export var NavigateToOrgHomeToolTip = "Go to enterprise home page";
export var WikiPageViewsBadgeTextFormat = "{0} {1} Views";
export var ContinueEditButtonText = "Continue edit";
export var NavigateAwayDialog_NamedMessage_ContinueEdit = "You have unsaved changes made to page \u0027{0}\u0027 which will be lost if you navigate away. Would you like to continue editing?";
export var WikiPickerUnpublishWikiActionText = "Unpublish wiki";
export var FolderLabel = "Folder:";
export var NameLabel = "Name:";
export var RepositoryLabel = "Repository:";
export var UnpublishWikiDialogConfirmButtonText = "Unpublish";
export var UnpublishWikiDialogMessage = "This will unpublish the wiki but it will have no impact on the markdown pages in the associated code repository. You can always publish the pages again from the code repository. ";
export var UnpublishWikiDialogSpinnerText = "Unpublishing wiki";
export var UnpublishWikiDialogTitle = "Unpublish wiki";
export var LinkListTitle = "Link";
export var RenamePageDialogAutoFixMove = "Moving page \u0027{0}\u0027 to \u0027{1}\u0027.";
export var RenamePageDialogCommitMessage = "Fixed broken link on page rename";
export var WikiPageListTitle = "Page";
export var WorkItemListTitle = "Work item";
export var OperationStatusFailed = "Failed";
export var OperationStatusSuccess = "Success";
export var PageMoveFailureMessage = "We were unable to move the page. You can try again later.";
export var PageMoveSuccessMessage = "Page moved successfully from \u0027{0}\u0027 to \u0027{1}\u0027.";
export var UpdateLinksFailedWarningMessage = "We were unable to fix all the links.";
export var BrokenLinkZeroDataMessage = "No broken links found.";
export var RenamePageDialogAutoFixSetAsHomePage = "Setting \u0027{0}\u0027 as home page.";
export var SetAsHomePageFailureMessage = "We were unable to set as home page. You can try again later.";
export var SetAsHomePageSuccessMessage = "Page \u0027{0}\u0027 is successfully set as home page.";
export var LinkUpdatedAriaLabel = "Link successfully updated";
export var LinkUpdateFailedAriaLabel = "Link update failed";
export var LoadingWikiPageLinksText = "Loading broken wiki page links";
export var LoadingWorkItemsText = "Loading broken work item links";
export var SpinnerUpdatingText = "Updating";
export var PageRenameSuccessMessage = "Page renamed successfully from \u0027{0}\u0027 to \u0027{1}\u0027";
export var PageRenameTitleMessage = "Renaming page \u0027{0}\u0027 to \u0027{1}\u0027.";
export var FixBrokenLinksInitialTitleNote = "Note: The list may not contain links to recently created or modified pages.";
export var FinishButtonText = "Finish";
export var LoadMoreLabel = "Loading more results";
export var PageLinksPivotTitle = "Page links";
export var ShowMoreText = "Show more";
export var WorkItemsPivotTitle = "Work items";
export var BrokenLinkUpdateStatusTitle = "Status";
export var CheckAffectedLinksButtonText = "Check affected links";
export var FixAndMoveButtonText = "Fix and move";
export var FixAndRenameButtonText = "Fix and rename";
export var MoveWithoutFixingButtonText = "Move without fixing";
export var RenameWithoutFixingButtonText = "Rename without fixing";
export var UnpublishBranchCtaText = "Unpublish branch";
export var UnpublishWikiCtaText = "Unpublish wiki";
export var WikiVersionErrorPrimaryText = "Where is my wiki?";
export var WikiBranchErrorSecondaryText = "Branch \u0027{0}\u0027 is not available any more";
export var OperationInProgressAriaLabel = "Operation \u0027{0}\u0027 is in progress. ";
export var WikiVersionErrorCtaFailureText = "We\u0027re having trouble completing the operation. Please try again.";
export var WikiVersionErrorCtaNoPermissionMessage = "You do not have sufficient permissions to perform this action. Contact your administrator for necessary permissions.";
export var TemplatesCycleDetectedMessage = "can\u0027t render file: {0}, cyclic dependency of templates detected.";
export var TemplateNotFoundMessage = "template {0} does not exist";
export var TreeFilterTryWikiSearch = "Don\u0027t see what you are looking for?";
export var WikiSearch = "Wiki Search ";
export var WordTry = "Try";
export var VersionPickerDraftVersionText = "Draft versions";
export var EditInDraftVersionDialog_Title = "Select a draft version to edit";
export var EditInDraftVersionDialog_NoDraftVersionText = "No draft versions available";
export var EditInDraftVersionButtonText = "Edit in draft version";
export var RemoveDraftVersionCtaText = "Remove draft version";
export var WikiCodeVersionErrorPrimaryText = "Lost wiki";
export var WikiCodeVersionErrorSecondaryText = "Looks like the branch \u0027{0}\u0027 associated with the wiki is deleted.";
export var InsertTOCText = "Insert table of contents";
export var TOCText = "Table of Contents";
export var InsertTOSPText = "Insert table of subpages";
export var TOSPText = "Table of Subpages";
export var InsertIncludesText = "Insert template";
export var IncludesText = "Templates";
export var RenameWikiCommand = "Rename wiki";
export var RenameWikiDialog_Title = "Rename wiki";
export var RenameWikiDisclaimer = "Renaming Wiki can break bookmarks and external references to Wiki pages.";
export var RenameWikiOk = "Rename";
export var RenameWikiOkAria = "Attempts to change wiki name.";
export var RenameWikiExit = "Cancel";
export var RenameWikiExitAria = "Exit rename dialog.";
export var RenameWikiTitle = "Rename the {0} wiki";
export var RenameWikiTexteBoxLabel = "Name";
export var WikiInvalidNameMessage = "The wiki name is invalid.";
export var HelpIconAriaLabel = "Help";
export var ResultsFoundPlural = "{0} results found.";
export var ResultsFoundSingular = "1 result found";
export var AddIncludeText = "Add template";
export var IncludesPrimaryMessage = "Reuse content, reduce redundancy.";
export var IncludesSecondaryMessage = "Templates are reusable markdown pages that can be used within multiple wiki pages.";
export var PathLabel = "Path";
export var MermaidLearningBubbleText = "Create flowcharts, sequence diagrams and Gantt charts using Mermaid diagrams in wiki.";
export var MermaidLearningBubbleCtaLabel = "Got it";
export var WikiEditPageLoadingText = "Loading";
export var WikiEditPageDeletedDialogTitle = "Page deleted";
export var WikiEditPageDeletedDialogMessage = "Unable to edit page as page does not exist. Please refresh to continue.";
export var WikiEditPageDeletedDialogCtaLabel = "Close";
